/* unplugin-vue-components disabled */import { render } from "./SaleForm.vue?vue&type=template&id=09bb5bbd&scoped=true&ts=true"
import script from "./SaleForm.vue?vue&type=script&lang=ts"
export * from "./SaleForm.vue?vue&type=script&lang=ts"

import "./SaleForm.vue?vue&type=style&index=0&id=09bb5bbd&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09bb5bbd"]])

export default __exports__